const styles = {
  noMarginBottom: {
    marginBottom: '0 !important',
  },
};

export default styles;
